

export const examples = [];

examples.push({
  "entityMap": {
    "2ecd2e37-92f2-44fc-a3f8-9f7d5e943bd6": "packing a lunch",
    "b88a0bf9-76d6-43b1-9bfd-93117646cf47": "making a sandwich",
    "2e910496-7d8f-4b1e-a40c-0515b6050120": "selecting a fruit",
    "4bf32161-2825-4e29-809f-2eaf61a656a2": "choosing a treat"
  },
  "children": [
    {
      "claimSet": null,
      "parent": null,
      "editorState": {
        "blocks": [
          {
            "key": "14aoq",
            "text": "for packing a lunch, comprising:",
            "type": "unstyled",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 4,
                "length": 15,
                "key": 0
              }
            ],
            "data": {}
          },
          {
            "key": "3js3o",
            "text": "\"Text in double quotes is not part of the claim, but will appear in the written description.  The first line is special -- it completes the claim preamble.\"",
            "type": "unstyled",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [],
            "data": {}
          },
          {
            "key": "5gfrg",
            "text": "making a sandwich with bread and cheese ",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 0,
                "length": 17,
                "key": 1
              }
            ],
            "data": {}
          },
          {
            "key": "9l389",
            "text": "\"Quoted text modifies the claim element that precedes it.\"",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [],
            "data": {}
          },
          {
            "key": "63doi",
            "text": "selecting a fruit \"Quoted text can instead appear on the same line at the end of the claim element. \"",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 0,
                "length": 17,
                "key": 2
              }
            ],
            "data": {}
          },
          {
            "key": "ckq6f",
            "text": "choosing a treat \"Check out the Claims, Figs., and Text tabs at right.\"",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 0,
                "length": 16,
                "key": 3
              }
            ],
            "data": {}
          }
        ],
        "entityMap": {
          "0": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          },
          "1": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          },
          "2": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          },
          "3": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          }
        }
      },
      "preamble": "packing a lunch",
      "claimType": "ind",
      "claimClass": "method",
      "entity": null,
      "children": [
        {
          "claimSet": null,
          "parent": null,
          "editorState": {
            "blocks": [
              {
                "key": "7nk89",
                "text": "includes:",
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              },
              {
                "key": "br6p2",
                "text": "\"This is a 'wherein-type' dependent claim.  It modifies an entity.  You can define new entities by selecting text and clicking the button on the menu bar.  If you change the entity in the menu pane at right, it will change everywhere in your claim set.\"",
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              },
              {
                "key": "2frjb",
                "text": "setting up a ladder ",
                "type": "unordered-list-item",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              },
              {
                "key": "3m36b",
                "text": "picking the fruit from a tree",
                "type": "unordered-list-item",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              }
            ],
            "entityMap": {}
          },
          "preamble": "",
          "claimType": "dep/wi",
          "claimClass": "method",
          "entity": "selecting a fruit",
          "children": [],
          "drawFig": false,
          "figType": "process",
          "figNum": 0,
          "showWD": true,
          "viewOpen": true,
          "makeClaim": true,
          "tree": null
        },
        {
          "claimSet": null,
          "parent": null,
          "editorState": {
            "blocks": [
              {
                "key": "86fil",
                "text": "further comprising:",
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              },
              {
                "key": "14p7m",
                "text": "\"This is a 'further-comprising-type' dependent claim.  If you want to see how we draw it, select the Draw checkbox below.\"",
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              },
              {
                "key": "ef7m9",
                "text": "searching for the cheese in a refrigerator",
                "type": "unordered-list-item",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": [],
                "data": {}
              }
            ],
            "entityMap": {}
          },
          "preamble": "",
          "claimType": "dep/fc",
          "claimClass": "method",
          "entity": null,
          "children": [],
          "drawFig": false,
          "figType": "process",
          "figNum": 0,
          "showWD": true,
          "viewOpen": true,
          "makeClaim": true,
          "tree": null
        }
      ],
      "drawFig": true,
      "figType": "process",
      "figNum": "3A",
      "showWD": true,
      "viewOpen": true,
      "makeClaim": true,
      "tree": null
    }
  ],
  "parent": null,
  "claimSet": null,
  "figBase": 3
});


// ----------------------------------------------------------------------------

examples.push({
  "entityMap": {
    "2224186f-aaf5-41e5-9ab6-1c1c93ffc33d": "packing a lunch",
    "71c8be57-480a-4cad-a6e5-e8c03bf457c3": "making a sandwich",
    "4c0a5710-50ba-4b72-bba8-6bc96c9b6ddf": "selecting a fruit",
    "609fe6b6-4d82-4535-927c-0a578e8d40b0": "choosing a treat"
  },
  "children": [
    {
      "claimSet": null,
      "parent": null,
      "editorState": {
        "blocks": [
          {
            "key": "13rol",
            "text": "for packing a lunch, comprising:",
            "type": "unstyled",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 4,
                "length": 15,
                "key": 0
              }
            ],
            "data": {}
          },
          {
            "key": "f9rvt",
            "text": "making a sandwich with bread and cheese",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 0,
                "length": 17,
                "key": 1
              }
            ],
            "data": {}
          },
          {
            "key": "8p9i0",
            "text": "selecting a fruit \"In some embodiments, selecting a fruit includes picking the fruit from a tree\"",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 0,
                "length": 17,
                "key": 2
              },
              {
                "offset": 40,
                "length": 17,
                "key": 2
              }
            ],
            "data": {}
          },
          {
            "key": "a0fa7",
            "text": "choosing a treat",
            "type": "unordered-list-item",
            "depth": 0,
            "inlineStyleRanges": [],
            "entityRanges": [
              {
                "offset": 0,
                "length": 16,
                "key": 3
              }
            ],
            "data": {}
          }
        ],
        "entityMap": {
          "0": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          },
          "1": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          },
          "2": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          },
          "3": {
            "type": "TOKEN",
            "mutability": "MUTABLE",
            "data": {}
          }
        }
      },
      "preamble": "packing a lunch",
      "claimType": "ind",
      "claimClass": "method",
      "entity": null,
      "drawFig": true,
      "figNum": "3A",
      "tree": null,
      "children": []
    }
  ],
  "parent": null,
  "claimSet": null,
  "figBase": 3
});
  
